@import '../../style/layout/index';
@import '~bulma/sass/grid/columns';

/* This class is being extended from the ".column" class from bulma */
/* stylelint-disable-next-line selector-class-pattern */
.column {
  box-sizing: border-box; // Bulma relies on inherited styles for this rule.
  position: relative;
  margin-bottom: 1.5rem;

  &.is-hidden-mobile {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;

    @include medium-up() {
      /* stylelint-disable-next-line declaration-no-important */
      display: flex !important;
    }
  }

  &.is-hidden-tablett {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;

    @include large-up() {
      /* stylelint-disable-next-line declaration-no-important */
      display: flex !important;
    }
  }

  &.is-hidden-desktop {
    /* stylelint-disable-next-line declaration-no-important */
    display: none !important;

    @include xlarge-up() {
      /* stylelint-disable-next-line declaration-no-important */
      display: flex !important;
    }
  }

  @include medium-up() {
    margin-bottom: 0;
  }

  &::before {
    position: absolute;
    top: 0;
    display: var(--debug);
    content: '';
    width: calc(100% - 2 * var(--columnGap));
    height: 100%;
    margin: 0 auto;
    background-color: rgb(219 112 147 / 20%);
    outline: 1px solid rgb(219 112 147 / 40%);
    z-index: 100;
  }

  &:hover {
    &::before {
      background-color: rgb(219 112 147 / 30%);
    }
  }
}
